import React, { useContext, useState, useCallback } from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';

import DeleteFilterModal from './delete-filter';
import gridStyle from './grid-style.module.less';
import messages from './messages';
import SettingsActionMenu from './settings-action-menu';
import style from './style.module.less';
import { FILTERSET_EDITOR_TYPE_ORDER_FILTER } from '../../../../components/filter-editor/constants/filterset-editor-type';
import { FilterEditorContext } from '../../../../components/filter-editor/context';
import FilterEditorModal from '../../../../components/filter-editor/modal';
import NewFilterEditorModal from '../../../../components/filter-editor/modal/new-filter-modal';
import UserDateFormat from '../../../../components/user-date-format/index';
import { useModal } from '../../../../hooks/use-modal';

const GridRow = ({ orderFilterSetId }) => {
  const { filterSets, getNewTemporaryFilter, setFilterSetWithWorkingFilterId, setShouldFetchFilters } = useContext(FilterEditorContext);
  const { isOpen, open, close } = useModal();
  const filter = filterSets[orderFilterSetId];
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isNewFilterModalOpen, setIsNewFilterModalOpen] = useState(false);

  const openModal = useCallback(() => {
    setIsModalOpen(true);
  }, [setIsModalOpen]);

  const closeModal = useCallback(() => {
    setIsModalOpen(false);
  }, []);

  const closeNewFilterModal = useCallback(() => {
    setShouldFetchFilters(true);
    setIsNewFilterModalOpen(false);
  }, [setShouldFetchFilters]);

  const intl = useIntl();

  const openCopyModal = useCallback(() => {
    setIsNewFilterModalOpen(true);
    const newFilterId = getNewTemporaryFilter();
    setFilterSetWithWorkingFilterId({
      ...filter,
      name: `${filter.name} ${intl.formatMessage(messages.copyFilterAppend)}`,
      orderFilterSetId: newFilterId,
    });
  }, [getNewTemporaryFilter, setFilterSetWithWorkingFilterId, filter, intl]);

  return (
    <div className={gridStyle['grid-row']} role='row'>
      <div className={gridStyle['grid-item']}>
        <span className={gridStyle.truncated}>{filter.name}</span>
      </div>
      <div className={gridStyle['grid-item']}>
        <span className={gridStyle.truncated}>{filter.description}</span>
      </div>
      <div className={classnames(gridStyle['grid-item'], style['last-modified'])}>
        <UserDateFormat value={filter.modifyDate} />
      </div>
      <div className={classnames(style.actions, gridStyle['grid-item'])}>
        <SettingsActionMenu openCopyModal={openCopyModal} openDeleteFilterModal={open} openModal={openModal} />
      </div>
      {isModalOpen ? (
        <FilterEditorModal
          filterId={filter.orderFilterSetId}
          filtersetEditorType={FILTERSET_EDITOR_TYPE_ORDER_FILTER}
          onClose={closeModal}
        />
      ) : null}
      {isNewFilterModalOpen ? (
        <NewFilterEditorModal filtersetEditorType={FILTERSET_EDITOR_TYPE_ORDER_FILTER} onClose={closeNewFilterModal} />
      ) : null}
      {isOpen ? <DeleteFilterModal closeModal={close} orderFilterSetId={orderFilterSetId} /> : null}
    </div>
  );
};

GridRow.propTypes = {
  orderFilterSetId: PropTypes.number.isRequired,
};

export default GridRow;
